import React from 'react';
import { HomeOutlined, RollbackOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { NotFoundTranscription, OrderTranscription } from 'config/constants/transcription.constant';
import styles from './style.module.scss';

type PaymentActionsProps = {
  onRetryPurchase: () => void;
  onGoHome: () => void;
};

const PaymentActions: React.FC<PaymentActionsProps> = ({ onRetryPurchase, onGoHome }) => {
  return (
    <div className={styles['action-buttons-container']}>
      <Button type='primary' size='large' icon={<RollbackOutlined />} className={styles['retry-btn']} onClick={onRetryPurchase}>
        {OrderTranscription.RETRY_PURCHASE}
      </Button>
      <Button type='text' size='large' icon={<HomeOutlined />} className={styles['home-btn']} onClick={onGoHome}>
        {NotFoundTranscription.NOT_FOUND_BUTTON_HOME_TEXT}
      </Button>
    </div>
  );
};

export default PaymentActions;
